import axios from "@/plugins/axios";

// Pendapatan Isi Rumah Bulanan mengikut Kumpulan Etnik (Kaum) & Strata.
// Combines Purata + Penengah into one kaum × strata table (Bandar / Luar Bandar
// / Jumlah per year). Years are discovered server-side and returned in
// `data.years`; `data.purata` and `data.penengah` each hold rows of
// { kaum, strata:{ Bandar:{y:v}, 'Luar Bandar':{y:v}, Jumlah:{y:v} } }.
export default class kaumXstrataServices {
  // params: { NG?, DP?, P (csv pusingan), S ("1"|"2"|"3") }
  async getKaumStrata(params = {}) {
    const res = await axios.get(
      `${process.env.VUE_APP_API_URL}/JadualAwalan/getKaumStrataJR2`,
      { params }
    );
    return (res.data && res.data.data) || {};
  }
}
